<template>
  <header :class="{ scrolled, desktop: !mobileView, mobile: mobileView, open: menuOpen }">
    <template v-if="!mobileView">
      <div>
        <div class="name" :title="fullname">
          <router-link to="/"><span>{{ fullname }}</span></router-link>
          <!-- <router-link to="/" v-html="animatableFullname"></router-link> -->
        </div>
        <nav>
          <ul>
            <li v-for="(nav, idx) in navigation" :key="`header-nav-${idx}`" :style="`--idx: ${idx+1}`">
              <router-link :to="`/${nav.slug}`">
                <span>{{ nav.label }}</span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </template>
    <template v-else>
      <div>
        <div class="name" :title="fullname" @click="menuOpen = false">
          <router-link to="/" v-html="animatableFullname" />
        </div>
        <button class="menu-btn" @click="toggleMobileMenu">
          <span/><span/><span/>
        </button>
      </div>
      <nav>
        <ul>
          <li v-for="(nav, idx) in navigation" :key="`header-nav-${idx}`" :style="`--idx: ${idx+1}`" @click="menuOpen = false">
            <router-link :to="`/${nav.slug}`">
              <span>{{ nav.label }}</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </template>
  </header>
</template>

<script>
  export default {
    name: 'Header',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        scrolled: false,
        menuOpen: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      fullname() {
        const prop = 'header.artist';
        const i18n = this.$i18n;
        if (i18n.te(prop)) {
          const { firstname, lastname } = i18n.t(prop);
          return `${firstname} ${lastname}`;
        }
        return null;
      },
      animatableFullname() {
        const prop = 'header.artist';
        const i18n = this.$i18n;
        if (i18n.te(prop)) {
          const { firstname, lastname } = i18n.t(prop);
          const fnLetter = firstname[0];
          const lnLetter = lastname[0];
          const fnRest = firstname.substr(1);
          const lnRest = lastname.substr(1);
          return `<span class="f">${fnLetter}</span><span class="r">${fnRest}</span><span class="r">&nbsp;</span><span class="f">${lnLetter}</span><span class="r">${lnRest}</span>`;
        }
        return null;
      },
      navigation() {
        const prop = 'header.navigation';
        const i18n = this.$i18n;
        if (i18n.te(prop)) {
          return i18n.t(prop);
        }
        return [];
      },
      mobileView() {
        return this.$b.clientWidth <= 768;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      window.addEventListener('click', this.handleWindowClick);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    // beforeUpdate() {},
    // updated() {},
    beforeDestroy() {
      window.removeEventListener('click', this.handleWindowClick);
      window.removeEventListener('scroll', this.handleScroll, { passive: true });
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      toggleMobileMenu() {
        this.menuOpen = !this.menuOpen;
      },
      handleWindowClick(evt) {
        if (this.menuOpen && !this.$el.contains(evt.target)) {
          this.menuOpen = false;
        }
      },
      handleScroll() {
        const y = document.documentElement.scrollTop;
        const threshold = 40;
        this.scrolled = y >= threshold;
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

header.desktop {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background: white;
  width: 100%;
  height: 110px;
  max-height: 110px;
  margin: 0 auto;
  padding-top: 5px;
  z-index: 100;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0);
  will-change: box-shadow, max-height;
  transition: max-height $default-transition, box-shadow $default-transition;
  overflow: hidden;
  line-height: initial;

  & > div {
    position: relative;
    @include max-width-constraints;
    margin: 0 auto;
    width: 100%;

    a {
      text-decoration: none;
      color: inherit;
      background: linear-gradient(90deg, $color-black 50%, transparent 50%);
      background-repeat: no-repeat;
      background-color: white;
      background-size: 200% 100%;
      background-position: -101% 100%;
      transition: background-position $default-transition;

      & > span {
        position: relative;
        top: -1px;
        padding: 4px 8px;
        color: white;
        mix-blend-mode: difference;
      }

      &:hover {
        background-position: 0 100%;
        animation: nav-anchors-hover $default-transition;
      }
    }

    & > .name {
      display: inline-block;
      position: relative;
      left: 50%;
      @include font-light;
      font-size: 3.2rem;
      text-transform: uppercase;
      opacity: 0;
      transform: translate(-50%, 0);
      will-change: opacity, transform, left;
      animation: fade-from-top-centered 0.5s ease-out forwards;

      & > a {
        padding: 4px 8px;
        & > span {
          position: relative;
          top: 5px;
          padding: 0;
          display: inline-block;
          overflow: hidden;
          max-width: 100%;
          transition: max-width 1s ease;
        }
      }
    }

    & > nav {
      position: relative;
      width: 100%;
      text-align: center;
      opacity: 0;
      transform: translate(0, 0);
      will-change: opacity, transform;
      animation: fade-from-top 0.35s 0.2s ease-out forwards;

      & > ul {
        position: relative;
        left: 0;
        transform: translate(0,0);
        list-style-type: none;
        padding: 20px 0;
        margin: 0 auto;
        display: inline-flex;
        justify-content: center;
        gap: 25px;
        overflow: hidden;

        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 1px;
          top: 10px;
          left: 0;
          background: linear-gradient(0, transparent 70%, black 99%);
          background-size: 100% 100%;
        }


        & > li {
          position: relative;
          top: 4px;
          padding: 0;
          margin: 0;

          animation-name: fade-from-top;
          animation-duration: 350ms;
          animation-delay: calc(250ms + (var(--idx) * 100ms));
          animation-fill-mode: forwards;
          animation-timing-function: ease-out;
          opacity: 0;
          transform: translate(0, 0);
          will-change: opacity, transform;

          a {
            text-decoration: none;
            color: currentColor;
            text-transform: uppercase;
            @include font-light;
            background: linear-gradient(90deg, $color-black 50%, transparent 50%);
            background-color: white;
            background-repeat: no-repeat;
            background-size: 200% 100%;
            background-position: -102% 100%;
            transition: background-position $default-transition;

            &.router-link-active {
              background-position: 0 100%;
              animation: nav-anchors-hover $default-transition;
            }
          }
        }
      }
    }
  }

  &.scrolled {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    max-height: 60px;
    & > div {
      & > .name {
        z-index: 2;
        animation: menu-retract-name 1s ease forwards;

        & > a > span.r {
          max-width: 0;
        }
      }


      & > nav {
        top: -55px;

        & > ul {
          opacity: 0;
          animation: menu-scrolled-fadein 0.5s ease forwards 0.15s;
          &:before {
            opacity: 0;
          }
        }
      }
    }
  }
}

header.mobile {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background: white;
  width: 100%;
  height: 60px;
  margin: 0 auto;
  padding-top: 5px;
  z-index: 100;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  overflow: hidden;

  & > div {
    position: relative;
    @include max-width-constraints;
    margin: 0 auto;
    width: 100%;
    height: 100%;

    a {
      text-decoration: none;
      color: inherit;
      background-color: white;

      & > span {
        position: relative;
        top: -1px;
        padding: 4px 8px;
        color: white;
        mix-blend-mode: difference;
      }
    }

    & > .name {
      display: inline-block;
      position: relative;
      @include font-light;
      font-size: 3.2rem;
      text-transform: uppercase;
      opacity: 1;

      & > a {
        padding: 4px 8px;
        & > span {
          pointer-events: none;
          position: relative;
          top: 5px;
          padding: 0;
          display: inline-block;
          overflow: hidden;
          max-width: 100%;
          transition: max-width 0.75s ease;
        }
      }
    }

    & > button.menu-btn {
      position: absolute;
      top: 7px;
      right: 30px;
      width: 40px;
      height: 38px;
      cursor: pointer;
      outline: 0;
      border: 0;
      background: transparent;

      & > span {
        position: absolute;
        left: calc(50% - 20px);
        top: calc(50% - 1.5px);
        display: block;
        background-color: black;
        width: 40px;
        height: 2px;
        transition: transform $default-transition;

        &:nth-child(1) { transform: translateY(-6.5px) }
        &:nth-child(3) { transform: translateY(6.5px) }
      }
    }
  }

  & > nav {
    position: fixed;
    top: 60px;
    right: 0;
    z-index: 0;
    width: 90%;
    height: calc(100vh - 60px);
    transform: translate(100%, 0);
    background: rgba(255,255,255, 0.96);
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    will-change: transform;

    & > ul {
      position: relative;
      top: -30px;
      left: -30px;
      transform: translate(0,0);
      list-style-type: none;
      padding: 20px 0;
      margin: 0 auto;

      & > li {
        position: relative;
        padding: 0;
        margin: 1.5vw 0;

        a {
          text-decoration: none;
          color: currentColor;
          text-transform: uppercase;
          @include font-light;
          font-size: 6vw;

          & > span {
            position: relative;
            top: -1px;
            padding: 4px 8px;
          }

          &.router-link-exact-active {
            background-repeat: no-repeat;
            background-color: black;
            color: white;
          }
        }
      }
    }
  }

  &.scrolled {
    & > div {
      & > .name {
        & > a > span.r {
          max-width: 0;
        }
      }
    }
  }

  &.open {
    overflow: visible;

    & > nav {
      transform: translate(0, 0);
      transition: transform $default-transition;
    }
    & > div {
      & > button.menu-btn > span {
        &:nth-child(1) { transform: rotate(45deg) translate(-1px,-1px); }
        &:nth-child(2) { transform: scale(0); }
        &:nth-child(3) { transform: rotate(-45deg) translate(1px,-1px); }
      }
    }
  }
}
</style>
